import NavRoutes from '../../common/NavRoutes'

export default [
  {
    id: 'junctionParameters',
    title: 'Junction Parameters',
    children: [
      {
        id: 'specifications',
        title: 'Specifications',
        children: [
          {
            id: 'phaseFlow',
            title: 'Phase Flow',
            navLink: NavRoutes.phaseFlow,
          },
          {
            id: 'signalOutput',
            title: 'Signal Output',
            navLink: NavRoutes.signalOutput,
          },
          {
            id: 'phaseDemand',
            title: 'Phase Demand',
            navLink: NavRoutes.phaseDemand,
          },
          {
            id: 'phaseConfig',
            title: 'Phase Config',
            navLink: NavRoutes.phaseConfig,
          },
          {
            id: 'systemInputs',
            title: 'System Inputs',
            navLink: NavRoutes.systemInputs,
          },
        ],
      },
    ],
  },
]
